const investmentElecConsumption = {
  state: {
    pageType: 'list',
    beginUpdate: new Date(),
    contractId: null
  },
  mutations: {
    set_investment_elec_consumption_pageType (state, data) {
      state.pageType = data
    },
    set_investment_elec_consumption_update (state, data) {
      state.beginUpdate = data
    },
    set_investment_elec_consumption_contractId (state, data) {
      state.contractId = data
    }
  },
  getters: {

  },
  actions: {

  }
}
export default investmentElecConsumption
